export default "__VITE_ASSET__vsPc$YeZ__"